<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
    <div class="top">
        <a [routerLink]="returnLink" [queryParams]="{ tab: 'grupos' }">
            <h3>Vacaciones protocolos /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>{{ isEditMode ? (ruleGroup.name || 'Editar regla') : 'Nueva regla' }}</h2>
            </div>
        </a>
    </div>
</div>

<form [formGroup]="ruleGroupForm" class="content">
    <!-- Form fields will be added here -->
    <h4>Nombre de la regla:</h4>
    <mat-form-field appearance="outline" id="title-form-field">
        <input type="text" matInput placeholder="Nombre de la regla" formControlName="name">
        @if (ruleGroupForm.get('name')?.invalid && ruleGroupForm.get('name')?.touched) {
        <mat-error>
            El nombre es requerido
        </mat-error>
        }
    </mat-form-field>

    <br><br><br>
    <div class="buttons">
        <button mat-flat-button id="action" type="button" (click)="saveChanges()"
            [disabled]="isSubmitting || ruleGroupForm.invalid">
            @if (isSubmitting) {
            {{ isEditMode ? 'Actualizando...' : 'Guardando...' }}
            } @else {
            {{ isEditMode ? 'Actualizar' : 'Guardar cambios' }}
            }
        </button>
        <button mat-flat-button id="cancel" type="button" (click)="cancel()">Cancelar</button>
    </div>
</form>
